var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-scroll-view",
    { attrs: { tag: "w-container" } },
    [
      _c(
        "w-row",
        [
          _c(
            "w-col",
            [
              _c("app-browse-list", {
                attrs: { browses: _vm.shownBrowses, title: _vm.$ct("views") },
                on: {
                  click: function ($event) {
                    return _vm.onBrowseClick($event)
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "w-col",
            { attrs: { sm: "12", md: "6" } },
            [
              _c(
                "w-card",
                [
                  _c("w-card-title", [
                    _vm._v(" " + _vm._s(_vm.$ct("common.settings")) + " "),
                  ]),
                  _c(
                    "w-card-content",
                    [
                      _c(
                        "w-row",
                        [
                          _c(
                            "w-col",
                            { attrs: { xs: "12" } },
                            [
                              _c("w-switch", {
                                attrs: {
                                  label: _vm.$ct("open-modal-in-extra-tab"),
                                  space: "",
                                  value: _vm.openModalInExternalTab,
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.setOpenModalInExternalTab($event)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { xs: "12" } },
                            [
                              _c("w-switch", {
                                attrs: {
                                  label: _vm.$ct("use-checkboxes-in-views"),
                                  space: "",
                                  value: _vm.useCheckboxesInViews,
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.setUseCheckboxesInViews($event)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { xs: "12" } },
                            [
                              _c("w-switch", {
                                attrs: {
                                  label: _vm.$ct("compact-view"),
                                  space: "",
                                  value: _vm.compactView,
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.setCompactView($event)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { xs: "12" } },
                            [
                              _c("w-switch", {
                                attrs: {
                                  label: _vm.$ct("double-click-opens-edit"),
                                  space: "",
                                  value: _vm.doubleClickOpensEdit,
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.setDoubleClickOpensEdit($event)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { xs: "12" } },
                            [
                              _c("w-select", {
                                attrs: {
                                  label: _vm.$ct("product-search-sort-order"),
                                  items: _vm.productSearchSortItems,
                                  value: _vm.productSearchSortOrder,
                                  fancy: "",
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.setProductSearchSortOrder($event)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { xs: "12" } },
                            [
                              _c(
                                "w-row",
                                [
                                  _c("w-spacer"),
                                  _c(
                                    "w-button",
                                    {
                                      staticClass: "danger",
                                      on: { click: _vm.restoreViews },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$ct("restore-views")) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-col",
            { attrs: { xs: "12", md: "6" } },
            [_c("app-f3-settings")],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }